import React, { Component } from 'react';
import style from '../share/pageList.module.css';

import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DropDownWithLabel from '../../components/DropDownWithLabel.js';
import DatePickerWithLabel from '../../components/DatePickerWithLabel.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import Paging from '../../components/Paging.js';
//import * as utils from '../../components/Utils.js';
import BackDropLoading from '../../components/BackDropLoading.js';
//import axios from 'axios';
import TemplateV2 from '../../components/TemplateV2';
import * as utils from '../../Utils.js';


class BookingList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            dataObject: null,
            searchObject: null,
            //Page: 1
        };
        this.Page = 1;
    }
    componentDidMount() {

        this.props.appState.checkUser(this.props.appState);

        if (this.props.site === "hopinn") {
            this.props.appState.checkRoles(this.props.appState, ["HopinnAdmin", "SystemAdmin"]);
        }
        this.callGetData();
    }
    handleChange = (e) => {
        let searchObject = { ...this.state.searchObject };

        if (e.target.name === "companyId") {
            searchObject.companyId = e.target.value;
            searchObject.costCenterId = "";
            this.state.searchObject =searchObject;
            this.callGetData();
        }
        else{
            if (e.target.name === "dateType") {
                searchObject.dateType = e.target.value;
            }
            if (e.target.name === "dateFrom") {
                searchObject.dateFrom = e.target.value;
            }
            if (e.target.name === "dateTo") {
                //alert("xx");
                searchObject.dateTo = e.target.value;
            }
            if (e.target.name === "searchType") {
                searchObject.searchType = e.target.value;
            }
            if (e.target.name === "searchWord") {
                searchObject.searchWord = e.target.value;
            }
    
            if (e.target.name === "statusType") {
                searchObject.statusType = e.target.value;
            }
            if (e.target.name === "paymentType") {
                searchObject.paymentType = e.target.value;
            }
    
            if (e.target.name === "companyName") {
                searchObject.companyName = e.target.value;
            }
            if (e.target.name === "costCenter") {
                searchObject.costCenter = e.target.value;
            }
            if (e.target.name === "hotelType") {
                searchObject.hotelCode = e.target.value;
            }
            if (e.target.name === "roomCode") {
                searchObject.roomCode = e.target.value;
            }
            if (e.target.name === "costCenterId") {
                searchObject.costCenterId = e.target.value;
            }
    
            // if(e.target.name === "companyId"){
            //     searchObject.companyId = e.target.value;
            // }
            if (e.target.name === "costCenter") {
                searchObject.costCenter = e.target.value;
            }
            this.setState({
                searchObject: searchObject
            })
        }      
    }
    pagingClick = (page) => {
        this.Page = page;
        this.callGetData();
    }
    searchClick = () => {
        this.callGetData();
    }
    exportClick = () => {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/WorkflowReportRequest";
        let data = {};

        data.searchObject = this.state.searchObject;

        if (this.props.site === "company") {
            data.companyId = this.props.appState.userObject.companyId;
        }

        let appState = this.props.appState;
        let token = appState.userObject.Token;
        data.Page = this.Page;

        utils.callPost(url, token, data, this.exportCallBack);
    }
    exportCallBack = (res) => {

        let url = process.env.REACT_APP_API_END_POINT + "/WorkflowReport/bookingreport/" + res.Data;

        let windowName = "";
        window.open(url, windowName, "height=500,width=500", "_blank");

        this.setState({
            loading: false
        })

    }

    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/WorkflowList";
        let data = {};

        data.searchObject = this.state.searchObject;

        if (this.props.site === "company") {
            data.companyId = this.props.appState.userObject.companyId;
        }

        data.Page = this.Page;
        let appState = this.props.appState;
        let token = appState.userObject.Token;
        utils.callPost(url, token, data, this.callGetDataCallBack);

        this.setState({
            loading: true
        })
    }
    callGetDataCallBack = (res) => {
        let data = res.Data;
        this.setState({
            dataObject: { ...data },
            searchObject: data.searchObject,
            loading: false
        })
    }

    handleClick = (method, index, e) => {
        if (method === "details") {
            let url = "";
            if (this.props.site === "company") {
                url = "/management/company/workflow/details/" + e;
            }
            else {
                url = "/management/workflow/details/" + e;
            }
            window.location.href = url;
        }
    }

    renderTable() {
        let tableRow = [];
        let dataObject = this.state.dataObject;

        if (dataObject !== null) {
            let dataList = dataObject.dataList;

            for (let i = 0; i < dataList.length; i++) {
                let node = dataList[i];
                let bookingDate = utils.stringToDateWithTime(node.bookingDate);
                let dateIn = utils.stringToDateWithOutTime(node.dateIn);
                let dateOut = utils.stringToDateWithOutTime(node.dateOut);
                tableRow.push(
                    <tr key={i}>
                        <td ><div className={style.booking_ref} onClick={(e) => this.handleClick("details", null, node.bookingId)}>{node.bookingRef}</div></td>
                        <td>{node.status}</td>
                        <td>{node.paymentMethod}</td>
                        <td>{bookingDate}</td>
                        <td>{node.roomRef}</td>
                        <td>{dateIn}</td>
                        <td>{dateOut}</td>
                        <td>{node.tripNo}</td>
                        <td>{node.hotelName}</td>
                        <td>{node.roomTypeName}</td>
                        <td>{node.guests}</td>
                        <td>{node.booker}</td>
                        <td>{node.mastercompanyName}</td>
                        <td>{node.companyName}</td>
                        <td>{node.costCenter}</td>
                        <td>{node.roomExternalCode}</td>
                        <td>{node.rateExternalCode}</td>
                        <td>{utils.numberWithCommas(node.total)}</td>
                    </tr>
                );
            }
        }
        return (
            <div className={style.tableArea}>
                <table>
                    <thead>
                        <tr>
                            <th>Booking Ref</th>
                            <th>status</th>
                            <th>payment method</th>
                            <th>Booking Date</th>
                            <th>Room Ref</th>
                            <th>Date In</th>
                            <th>Date Out</th>
                            <th>Trip No</th>
                            <th>Branch</th>
                            <th>Room Type</th>
                            <th>Guest</th>
                            <th>Booker</th>
                            <th>Parent Company</th>
                            <th>Company</th>
                            <th>Cost center</th>
                            <th>RoomCode</th>
                            <th>RateCode</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </table>
                {dataObject !== null &&
                    <Paging dataObject={dataObject} onClick={this.pagingClick} />
                }
            </div>
        );
    }


    render() {
        let table = this.renderTable();
        //let table = "";

        if(this.state.searchObject !== null){
            //alert(this.state.searchObject.companyId);
            console.log(this.state.searchObject);
        }
        
        return (
            <TemplateV2 appState={this.props.appState} site={this.props.site} page={"workflow"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />

                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>Booking List</div>
                    </div>

                    {this.state.showCreate !== true && this.state.loading !== true && this.state.showDelete !== true && this.state.showDetail !== true &&

                        <>
                            <div className={style.searchArea}>
                                <div className={style.searchBox}>
                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.statusTypeList} value={this.state.searchObject.statusType} name="statusType" label="Status" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.paymentTypeList} value={this.state.searchObject.paymentType} name="paymentType" label="Payment Type" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.roomList} value={this.state.searchObject.roomCode} name="roomCode" label="Room Type" />
                                        </div>
                                    </div>
                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.dateTypeList} value={this.state.searchObject.dateType} name="dateType" label="Date Type" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateFrom} name="dateFrom" label="Date From" />
                                        </div>


                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateTo} name="dateTo" label="Date To" />
                                        </div>
                                    </div>

                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.searchTypeList} value={this.state.searchObject.searchType} name="searchType" label="Search Type" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.searchWord} name="searchWord" label="Search Word" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.hotelList} value={this.state.searchObject.hotelCode} name="hotelType" label="Hotel" />
                                        </div>
                                    </div>
                                    <div className={style.row}>
                                        {this.props.site !== "company" &&
                                            <div className={style.searchBoxInput}>
                                                <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.companyName} name="companyName" label="Company name" />
                                            </div>
                                        }
                                        {this.props.site === "company" &&
                                            // <div className={style.searchBoxInput}>
                                            //     <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.companyName} name="companyName" label="Company name" readOnly={true} />
                                            // </div>

                                            <div className={style.searchBoxInput}>
                                                <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.companyList} value={this.state.searchObject.companyId} name="companyId" label="Company list" />
                                            </div>
                                        }
                                        {this.state.searchObject.costcenterList !== null &&
                                            <div className={style.searchBoxInput}>
                                                <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.costcenterList} value={this.state.searchObject.costCenterId} name="costCenterId" label="Cost Center" />
                                            </div>
                                        }
                                        {this.state.searchObject.costcenterList === null &&
                                            <div className={style.searchBoxInput}>
                                                <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.costCenter} name="costCenter" label="Cost center" />
                                            </div>
                                        }
                                        <div className={style.searchBoxBtn}>
                                            <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                        </div>
                                        <div className={style.searchBoxBtn}>
                                            <DefaultBtn label="Export to excel" type="primary" onClick={this.exportClick} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={style.contentArea}>
                                <div className={style.contentBox}>
                                    <div className={style.contentTitle}>Booking List</div>
                                    <div className={style.line}></div>
                                    <div className={style.line}></div>
                                    {table}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </TemplateV2>
        );
    }
}
export default BookingList;